import React, { useEffect, useState } from 'react'
import AHeader from '../component/AHeader'
import AFooter from '../component/AFooter'
import axios from 'axios'
import { toast } from 'react-toastify'

function Manage_customer() {
    useEffect(() => {
        fetch()
        document.getElementById('spinner').style.display = "none";
    }, [])

    const [data, setData] = useState([])
    const fetch = async () => {
        const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/user_get`)
        console.log(res.data);
        setData(res.data)
    }

    const deletehandle = async (id) => {
        const res = await axios.delete(`https://www.rajvicosmeticclinic.com/RajviApi/user_delete?id=${id}`)
        toast.success('User Deleted Success');
        fetch();
    }

    const statushand = async (id) => {
        const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/user_status?id=${id}`);
        toast.success('Status update success');
        fetch();
        if (res.status == true) {
            localStorage.removeItem("userid");
            localStorage.removeItem("userName");
            localStorage.removeItem("useremail");
        }
    };
    return (
        <div>
            <AHeader title="Manage Customer" />
            < div className="container-fluid" >
                <div className="container">
                    <div className="row">
                        <div className=" col-lg-12 ">
                            <div className="bg-light  p-lg-5">
                                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">Customer</h6>
                                <h1 className="mb-4">Manage Customer</h1>
                                <div className='justify-content-center text-center mb-5' id='spinner'>
                                    <div class="spinner-border text-danger mt-5"></div>
                                </div>
                                <table className="table">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Password</th>
                                            <th>Mobile</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (data.length > 0) ? data && data.map((value) => {
                                                return (
                                                    <tr>
                                                        <td>{value.id}</td>
                                                        <td>{value.name}</td>
                                                        <td>{value.email}</td>
                                                        <td>{value.password}</td>
                                                        <td>{value.mobile}</td>
                                                        {/*
                                                <td>
                                                    <img src={`https://www.rajvicosmeticclinic.com/RajviApi/upload/user/${value.img}`}
                                                    height={50}
                                                    width={50}
                                                    alt="" />
                                                </td>
                                                */}
                                                        <td>
                                                            <button className='btn btn-info mr-2' onClick={() => statushand(value.id)}>   {value.status}</button>
                                                            <button className='btn btn-danger' onClick={() => deletehandle(value.id)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                )
                                            }) : null
                                        }

                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <AFooter />
        </div>
    )
}

export default Manage_customer